/**
 * @generated SignedSource<<d3368bedc712496ccc906977933dedf9>>
 * @relayHash ac67e1bbb441f9ad0b7fa76390536e2b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6f2f848d41ac537079da4685e982e32c0af1560635dfec776c830cde5062a9b8

var node = function () {
  var v0 = [{
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cloudId"
    }],
    v1 = {
      "args": [{
        "items": [{
          "kind": "Variable",
          "name": "cloudIds.0",
          "variableName": "cloudId"
        }],
        "kind": "ListValue",
        "name": "cloudIds"
      }],
      "concreteType": "TenantContext",
      "kind": "LinkedField",
      "name": "tenantContexts",
      "plural": true,
      "selections": [{
        "kind": "ScalarField",
        "name": "cloudId"
      }, {
        "kind": "ScalarField",
        "name": "cloudUrl"
      }, {
        "kind": "ScalarField",
        "name": "orgId"
      }, {
        "args": [{
          "kind": "Literal",
          "name": "product",
          "value": "confluence"
        }],
        "concreteType": "TenantContextActivationId",
        "kind": "LinkedField",
        "name": "activationIdByProduct",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "name": "product"
        }, {
          "kind": "ScalarField",
          "name": "active"
        }],
        "storageKey": "activationIdByProduct(product:\"confluence\")"
      }]
    },
    v2 = [{
      "kind": "Variable",
      "name": "cloudId",
      "variableName": "cloudId"
    }],
    v3 = {
      "kind": "InlineFragment",
      "selections": [{
        "kind": "ScalarField",
        "name": "isCompanyHubAvailable"
      }, {
        "concreteType": "AtlassianStudioUserProductPermissions",
        "kind": "LinkedField",
        "name": "userPermissions",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "name": "isConfluenceGlobalAdmin"
        }]
      }],
      "type": "AtlassianStudioUserSiteContextOutput"
    },
    v4 = {
      "kind": "ScalarField",
      "name": "id"
    },
    v5 = {
      "kind": "ScalarField",
      "name": "accountId"
    },
    v6 = {
      "kind": "ScalarField",
      "name": "__typename"
    };
  return {
    "fragment": {
      "argumentDefinitions": v0 /*: any*/,
      "kind": "Fragment",
      "name": "bootstrapHubQuery",
      "selections": [v1 /*: any*/, {
        "args": v2 /*: any*/,
        "kind": "LinkedField",
        "name": "atlassianStudio_userSiteContext",
        "plural": false,
        "selections": [v3 /*: any*/]
      }, {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [v4 /*: any*/, v5 /*: any*/]
        }]
      }],
      "type": "Query"
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0 /*: any*/,
      "kind": "Operation",
      "name": "bootstrapHubQuery",
      "selections": [v1 /*: any*/, {
        "args": v2 /*: any*/,
        "kind": "LinkedField",
        "name": "atlassianStudio_userSiteContext",
        "plural": false,
        "selections": [v6 /*: any*/, v3 /*: any*/]
      }, {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [v6 /*: any*/, v4 /*: any*/, v5 /*: any*/]
        }]
      }]
    },
    "params": {
      "id": "6f2f848d41ac537079da4685e982e32c0af1560635dfec776c830cde5062a9b8",
      "metadata": {},
      "name": "bootstrapHubQuery",
      "operationKind": "query",
      "text": null
    }
  };
}();
node.hash = "c3f5c6244e317a2cbad5fbdbbabf1b47";
export default node;